import { Box, styled } from '@mui/material';

import type { AutomaticRosteringProgressStepState } from 'generated';

export const StyledStepList = styled('ol')(({ theme }) => ({
  listStyle: 'none',
  margin: 0,
  padding: theme.spacing(2, 3),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.action.hover
}));

export const StyledStep = styled('li', {
  shouldForwardProp: (prop) => prop !== 'state'
})<{ state: AutomaticRosteringProgressStepState }>(({ theme, state }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  ...theme.typography.body2,
  color:
    state === 'PENDING'
      ? theme.palette.text.disabled
      : theme.palette.text.primary,
  fontWeight:
    state === 'RUNNING'
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular
}));

/** Same box for the icon and the spinner, so the labels line up whatever state a step is in. */
export const StyledStepIconBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: theme.spacing(4),
  flexShrink: 0
}));
